module.exports = __webpack_public_path__ + "img/cxTrends-9.8cd2aa7e.png";